module.exports = __webpack_public_path__ + "static/media/environmental.8cde471f.mp4";